import { useState, useEffect, useCallback } from 'react';
import {
    Container,
    Title,
    Button,
    Content,
    ListGroups,
    DetailsGroup,
    ConfigGroup
} from './styled';
import {
    FaUsers,
    FaAngleDoubleDown,
    FaAngleDoubleUp
} from "react-icons/fa";
import {
    IoAddCircle
} from "react-icons/io5";
import {
    Search,
    Modal
} from '../../../../components';
import {
    getAllGroups
} from '../../../../service/serviceChat/groupService';
import {
    LinkUsersGroup
} from './LinkUsersGroup';
import {
    NewGroup
} from './NewGroup';
import { RenameGroup } from './RenameGroup';
import {
    getUsers
} from '../../../../service/serviceChat/usersService';
import { RiEdit2Fill } from "react-icons/ri";

export function Groups() {

    const [groups, setGroups] = useState([]);
    const [users, setUsers] = useState([]);
    const [filter, setFilter] = useState('');
    const [groupSelected, setGroupSelected] = useState(null);
    const [openConfigGroup, setOpenConfigGroup] = useState(false);
    const [openNewGroup, setOpenNewGroup] = useState(false);
    const [renameGroup, setRenameGroup] = useState(null);

    const searchAllGroups = useCallback(async () => {
        setGroups(await getAllGroups())
    }, []);
    useEffect(() => {
        searchAllGroups()
    }, []);


    const handleNewGroup = async () => {
        setUsers(await getUsers())
        setOpenNewGroup(true)
    };
    const handleSelectGroup = async (group) => {
        setUsers(await getUsers())
        setGroupSelected(group)
    };
    const handleClose = () => {
        setUsers([])
        setGroupSelected(null)
        setOpenConfigGroup(false)
    };
    function onFilter(obj) {
        return (obj?.nomecompleto?.toLowerCase()?.includes(filter?.toLowerCase()))
    };


    return (
        <Container>
            <Title>
                <span>
                    <FaUsers fontSize={'3rem'} />
                </span>
                <div>
                    {`Setores`}
                </ div>
            </Title>
            <Content>
                <div>
                    <Search
                        className={`uFN`}
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        placeholder={`Buscar Setor`}
                    />
                    <Button onClick={() => handleNewGroup()}>
                        <IoAddCircle fontSize={'1.5rem'} />
                        {`Novo Setor`}
                    </Button>
                </div>

                <ListGroups>
                    <div>
                        <div>{`Código`}</div>
                        <div>{`Descrição`}</div>
                    </div>
                    <ul>
                        {groups?.filter(onFilter).map((group) => (
                            <li
                                key={`${group.id}`}
                                className={
                                    `${(groupSelected?.id === group.id)
                                        ? 'selected'
                                        : ''
                                    }`
                                }
                                onClick={() => handleSelectGroup(group)}
                            >
                                <p>{group.id}</p>
                                <p>{group.nomecompleto}</p>
                                <span onClick={() => setRenameGroup(group)}>
                                    <RiEdit2Fill fontSize={20} />
                                </span>
                            </li>
                        ))}
                    </ul>
                </ListGroups>
            </Content>
            <DetailsGroup expandir={(groupSelected)}>
                <Button
                    className={`${(openConfigGroup) ? 'Ds-none' : ''}`}
                    onClick={() => { setOpenConfigGroup(true) }}
                >
                    <FaAngleDoubleUp fontSize={'1.75rem'} />
                </Button>
                <Button
                    className={`${(!openConfigGroup) ? 'Ds-none' : ''}`}
                    onClick={() => handleClose()}
                >
                    <FaAngleDoubleDown fontSize={'1.75rem'} />
                </Button>
            </DetailsGroup>
            <ConfigGroup expandir={(openConfigGroup)}>
                <LinkUsersGroup
                    group={groupSelected}
                    usersAll={users}
                    callback={() => {
                        searchAllGroups()
                    }}
                />
            </ConfigGroup>
            <Modal
                title={`Novo Setor`}
                isOpen={(openNewGroup) ? 1 : 0}
                close={() => setOpenNewGroup(false)}
            >
                {(openNewGroup) &&
                    (<NewGroup
                        users={users}
                        callback={() => {
                            searchAllGroups()
                            setOpenNewGroup(false)
                        }}
                    />)
                }
            </Modal>
            <Modal
                title={`Renomear Setor`}
                isOpen={(renameGroup) ? 1 : 0}
                close={() => setRenameGroup(null)}
            >
                {(renameGroup) &&
                    (<RenameGroup
                        group={renameGroup}
                        callback={() => {
                            searchAllGroups()
                            setRenameGroup(null)
                        }}
                    />)
                }
            </Modal>
        </Container >
    );
}